import {
  initInfiniteSliders,
  observeRevealText,
  wrapCharsWithSpan
} from "../utils";

window.addEventListener("DOMContentLoaded", () => {
  wrapCharsWithSpan();
  observeRevealText();
  initInfiniteSliders();
});
